import { render, staticRenderFns } from "./info_nlp.vue?vue&type=template&id=0794c46c&scoped=true"
import script from "./info_nlp.vue?vue&type=script&lang=js"
export * from "./info_nlp.vue?vue&type=script&lang=js"
import style0 from "./info_nlp.vue?vue&type=style&index=0&id=0794c46c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0794c46c",
  null
  
)

export default component.exports